import React, { useEffect } from 'react'
import { useAnalyticsLayerContext } from '../../layers/analytics'
import { useTokenLayerContext } from '../../layers/token'


type Children = { children: React.ReactNode }
const Identification = ({ children }: Children) => {
  const { identify, report } = useAnalyticsLayerContext()
  const { userId } = useTokenLayerContext()

  useEffect(() => {
    if (!userId) report('[Identification] Unexpected value for userId', userId)
    identify(userId)
  }, [identify, userId, report])

  return <>{children}</>
}

export default Identification
